import '../../node_modules/jquery-validation/dist/jquery.validate';
import './signin/widgets/validate-form.js';
import './signin/widgets/button-state.js';
import './signin/widgets/global-error.js'
import './signin/forgot-password-submit';
import './signin/login-submit';
import './signin/reset-password-submit';
